export const getFooterTestId = (text: string, linkIndex: number): string => {
  const testIdType = linkIndex > 0 ? 'link' : 'category';

  return `${text?.split(' ')?.join('-')?.toLowerCase()}-${testIdType}`;
};

export const getTestId = (text: string) => {
  return `${text?.split(' ')?.join('-')?.toLowerCase()}`;
};
